import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseService } from '../../services/firebase.service';

@Component({
  templateUrl : 'logout.html',
  styleUrls   : [ 'logout.scss' ]
})

export class LogoutComponent implements OnInit {
  constructor(
    private firebaseService : FirebaseService,
    private router          : Router
  ) {}

  ngOnInit() : void {
    this.firebaseService.logout()
      .then(() => this.router.navigateByUrl('/')
      	.then(() => window.location.reload(false)));
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/components/logout/logout.ts